import React from "react";

export const SelectedIcon = () => {
  return (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 5.5L5.66667 9L13 2" stroke="#1973FF" strokeWidth="1.5" strokeLinecap="square" />
    </svg>
  );
};
